import type { TeamMemberType, TenantRole } from '@livechat/shared';

export function teamMemberRoleLabel(memberType: TeamMemberType, role: TenantRole): string {
	return memberType === 'ai_agent' ? 'AI Agent' : role;
}

export function assignedTeamMemberLabel(
	name: string | undefined,
	memberType: TeamMemberType | undefined,
	fallback: string,
): string {
	if (!name) return fallback;
	return memberType === 'ai_agent' ? `${name} · AI Agent` : name;
}
